import heIL, { Locale } from 'dayjs/locale/he';

const HebrewLocale: Locale = {
    ...heIL,
    weekdaysShort: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
};

export default HebrewLocale;
